<template>
    <div style="padding: 0 60px;">
        <div class="titles">{{title}}</div>
        <div v-html="content"></div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                title:'',
                content:''
            }
        },
        created(){
            let obj={}
            if(this.$route.params.type==1){
                obj.code='XY202405070002'
                this.title='全掌柜用户注册协议'
            }else{
                obj.code='XY202405070001'
                this.title='隐私协议'
            }
            this.getContent(obj)
        },
        methods:{
            getContent(obj){
                this.$axios.get('/agreementVersion/getEffectiveAgreementVersionByCode',obj).then(res=>{
                    this.content=res.content
                })
            }
        }
    }
</script>
<style scoped>
    .titles{
        padding-top: 16px;
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        padding-bottom: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/common/components/login/aggrement.vue